<template>
  <a-modal
    :title="title"
    v-if="showModal"
    :visible="showModal"
    class="small noticedetail"
    width="70%"
    :footer="null"
    @cancel="close"
    :dialogStyle="{ top: '50px' }"
    :closable="closable"
    destroyOnClose
    :maskClosable="false"
  >
    <div class="notice-detail-content">
      <h5 class="text-16px text-center">
        {{ noticeDetailState.noticeDetail?.title }}
      </h5>
      <div
        class="py-20px text-12px notice-content"
        v-html="noticeDetailState.noticeDetail?.content"
      ></div>
      <div class="border-t border-gray-200 border-solid text-12px py-10px">
        <div v-if="noticeDetailState.noticeDetail?.videoFileList?.length">
          <span class="text-color-[#818181]">附件视频：</span>
          <a-list
            class="!mt-10px"
            item-layout="horizontal"
            :data-source="noticeDetailState.noticeDetail?.videoFileList"
            bordered
          >
            <template #renderItem="{item}">
              <a-list-item>
                <a-list-item-meta :description="item.ossName">
                  <template #title>
                    <a class="text-12px" href="javascript:;">{{ item.size }}</a>
                  </template>
                  <template #avatar>
                    <a-avatar
                      src="https://oss-scm-prod.kapeixi.cn/cs-scm/2024-12-25/1735118220738-play_video.png?x-oss-process=image/format,webp/resize,w_800"
                    />
                  </template>
                </a-list-item-meta>
                <template #actions>
                  <a-button
                    size="small"
                    type="link"
                    class="mr-8px"
                    @click="handlePreview(item.ossUrl, 1)"
                    >预览</a-button
                  >
                  <a-button
                    size="small"
                    type="link"
                    v-if="noticeDetailState.noticeDetail?.isDownloadAllowed"
                    @click="downloadImg(item)"
                    >下载</a-button
                  >
                </template>
              </a-list-item>
            </template>
          </a-list>
        </div>
        <div
          class="mt-15px"
          v-if="noticeDetailState.noticeDetail?.fileList?.length"
        >
          <span class="text-color-[#818181]">附件文件：</span>
          <a-list
            class="!mt-10px"
            item-layout="horizontal"
            :data-source="noticeDetailState.noticeDetail?.fileList"
            bordered
          >
            <template #renderItem="{item}">
              <a-list-item>
                <a-list-item-meta :description="item.ossName">
                  <template #title>
                    <a class="text-12px" href="javascript:;">{{ item.size }}</a>
                  </template>
                  <template #avatar>
                    <a-avatar
                      src="https://oss-scm-prod.kapeixi.cn/cs-scm/2024-12-25/1735118225974-pdf.png?x-oss-process=image/format,webp/resize,w_800"
                    />
                  </template>
                </a-list-item-meta>
                <template #actions>
                  <a-button
                    size="small"
                    type="link"
                    class="mr-8px"
                    @click="handlePreview(item.ossUrl, 2)"
                    >预览</a-button
                  >
                  <a-button
                    v-if="noticeDetailState.noticeDetail?.isDownloadAllowed"
                    size="small"
                    type="link"
                    @click="downloadImg(item)"
                    >下载</a-button
                  >
                </template>
              </a-list-item>
            </template>
          </a-list>
        </div>
      </div>
      <div
        class="text-center mt-20px"
        v-if="
          !isFromNotice && noticeDetailState.noticeDetail?.isReadStr === '未读'
        "
      >
        <a-button
          type="primary"
          @click="updateReadStatus"
          class="w-96px"
          :disabled="!!noticeDetailState.noticeDetail?.popupTime"
          >{{
            noticeDetailState.noticeDetail?.popupTime
              ? `已阅读(${noticeDetailState.noticeDetail?.popupTime}s)`
              : '已阅读'
          }}
        </a-button>
      </div>
    </div>
  </a-modal>
  <!-- 视频播放 -->
  <a-modal
    v-model:visible="noticeDetailState.videoVisible"
    v-if="noticeDetailState.videoVisible"
    title="查看视频"
    :footer="null"
    width="500px"
  >
    <video controls autoplay loop style="width: 100%; height: 100%">
      <source :src="noticeDetailState.videoUrl" />
      Your browser does not support the video tag.
    </video>
  </a-modal>
  <a-modal
    v-model:visible="noticeDetailState.fileVisible"
    v-if="noticeDetailState.fileVisible"
    title="预览"
    :footer="null"
    width="75%"
    class="file-modal"
  >
    <iframe
      :src="noticeDetailState.fileUrl"
      width="100%"
      height="700px"
    ></iframe>
  </a-modal>
</template>
<script setup>
import { inject, defineProps, defineEmits } from 'vue'
import { useNoticeDetail } from '../share'
import { downloadImg } from 'utils/file.js'
import { useStore } from 'vuex'
const store = useStore()
const props = defineProps({
  showDetail: {
    type: Boolean,
    default: false
  },
  id: {
    type: [String, Number],
    default: null
  },
  isFromNotice: {
    type: Boolean,
    default: false
  },
  toRead: {
    type: Function,
    default: () => {}
  },
  title: {
    type: String,
    default: '详情'
  }
})
const emit = defineEmits(['close'])
const noticePublishModule = inject('noticePublishModule')
const close = () => {
  emit('close')
}
const {
  noticeDetailState,
  handlePreview,
  updateReadStatus,
  showModal,
  closable
} = useNoticeDetail(props, emit, store)
</script>
<style lang="scss" scoped>
:deep(.ant-list-item-meta-description) {
  font-size: 12px;
}
:deep(.ant-list-item) {
  padding: 6px;
}
:deep(.ant-avatar) {
  border-radius: 0;
}
</style>
<style lang="scss">
.notice-detail-content {
  padding: 0 25px;
  max-height: 85vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
}
.noticedetail .ant-modal-close {
  right: 16px !important;
}
.notice-content p {
  padding: 5px 0;
  line-height: 20px;
}
.text-12px {
  font-size: 12px;
}
</style>
<style>
.file-modal.ant-modal {
  top: 30px;
}
</style>
